'use client';
import { useStore } from '@/providers/app-store-provider';
import { ReportingCenter } from '@/reporting';
import { ImpactRadiusProvider } from '@/reporting/providers/impactProvider';
import { ProviderType } from '@/reporting/types';
import { useWhenTokenReady } from '@/hooks/useWhenReady';
import logger from '@/utils/client-logger';

/**
 * Impact 绑定初始化 Hook
 * 主要用于页面初始化时处理 Impact Radius 参数绑定
 * - 游客用户：存储 irclickid 参数到 localStorage（30天）
 * - 登录用户：存储参数 + 调用 API 绑定（但用户登录后的绑定主要由 userSlice.ts 处理）
 */
export const useImpactBindInit = () => {
  const token = useStore((state) => state.token);
  const refreshAccountInfo = useStore((state) => state.refreshAccountInfo);
  const onBindSuccess = () => {
    if (token) {
      refreshAccountInfo();
    }
  };
  // * 现在没有登录也得bind_impact
  useWhenTokenReady(() => {
    const handleImpactBinding = async () => {
      try {
        const center = ReportingCenter.getInstance();
        const impactProvider = center.getProvider(
          ProviderType.IMPACT_RADIUS,
        ) as ImpactRadiusProvider;

        if (impactProvider) {
          // 直接使用封装好的bindImpact方法，它会自动处理：
          // 1. 从URL参数或localStorage获取irclickid
          // 2. 设置30天过期时间（游客和登录用户都需要）
          // 3. 如果有token就调用后端API绑定（但用户登录后的绑定主要由userSlice.ts处理）
          // 4. 绑定成功后删除localStorage中的irclickid
          await impactProvider.bindImpact(onBindSuccess);
        }
      } catch (error) {
        logger.error('Failed to handle impact binding:', error);
      }
    };

    handleImpactBinding();
  }, [refreshAccountInfo]); // 依赖 refreshAccountInfo
};
